import { createForm } from '../../../factories'

export default createForm(['name', 'description', 'active'])



// WEBPACK FOOTER //
// ./src/store/modules/topics/forms/update.js